import { takeEvery, takeLatest } from "redux-saga/effects";

import { CoachmarkEntityActionType } from "entities/coachmarks/actionTypes";
import { fetchCoachmarksSaga } from "entities/coachmarks/sagas/fetchCoachmarksSaga";
import { EventType } from "entities/events/actionTypes";
import { fetchEventsByIdSaga } from "entities/events/sagas/fetchEventByIdSaga";
import { fetchEventsForTopicSaga } from "entities/events/sagas/fetchEventsForTopicSaga";
import { InitiativesType } from "entities/initiatives/actionTypes";
import { fetchInitiativeByIdSaga } from "entities/initiatives/sagas/fetchInitiativeByIdSaga";
import { fetchInitiativesForTopicSaga } from "entities/initiatives/sagas/fetchInitiativesForTopicSaga";
import { KnowledgeActionTypes } from "entities/knowledge/actionTypes";
import { knowledgeItemSaga } from "entities/knowledge/sagas/fetchKnowledgeByIdSaga";
import { KnowledgeDataActionTypes } from "entities/knowledgeData/actionTypes";
import { fetchKnowledgeDataForTopicSaga } from "entities/knowledgeData/sagas/fetchKnowledgeDataForTopicSaga";
import { KnowledgeFeedActionTypes } from "entities/knowledgeFeed/actionTypes";
import { fetchKnowledgeFeedForTopicSaga } from "entities/knowledgeFeed/sagas/fetchKnowledgeFeedForTopicSaga";
import { LanguageActionTypes } from "entities/languages/actionTypes";
import { fetchLanguagesSaga } from "entities/languages/sagas/fetchLanguagesSaga";
import { PublicationActionTypes } from "entities/publication/actionTypes";
import { fetchPublicationForTopicSaga } from "entities/publication/sagas/fetchPublicationForTopicSaga";
import { StakeholderActionTypes } from "entities/stakeholders/actionTypes";
import { fetchStakeholderByIdSaga } from "entities/stakeholders/sagas/fetchStakeholderByIdSaga";
import { fetchStakeholdersForTopicSaga } from "entities/stakeholders/sagas/fetchStakeholdersForTopicSaga";
import { TopicActionType } from "entities/topics/actionTypes";
import { fetchFollowedTopicsSaga } from "entities/topics/sagas/fetchFollowedTopicsSaga";
import { fetchHighlightedTopicsSaga } from "entities/topics/sagas/fetchHighlightedTopicsSaga";
import { fetchTopicSaga } from "entities/topics/sagas/fetchTopicSaga";
import { fetchTopicsForCollectionSaga } from "entities/topics/sagas/fetchTopicsForCollectionSaga";
import { fetchTopicsOfTypeSaga } from "entities/topics/sagas/fetchTopicsOfTypeSaga";
import { VideoActionTypes } from "entities/videos/actionTypes";
import { fetchVideosForTopicSaga } from "entities/videos/sagas/fetchVideosForTopicSaga";

export const entitiesSagaSpawners = [
  takeLatest(CoachmarkEntityActionType.FETCH, fetchCoachmarksSaga),
  takeEvery(PublicationActionTypes.FETCH_FOR_TOPIC, fetchPublicationForTopicSaga),
  takeEvery(KnowledgeFeedActionTypes.FETCH_FOR_TOPIC, fetchKnowledgeFeedForTopicSaga),
  takeEvery(KnowledgeActionTypes.FETCH_FOR_ID, knowledgeItemSaga),
  takeEvery(InitiativesType.FETCH_FOR_ID, fetchInitiativeByIdSaga),
  takeEvery(InitiativesType.FETCH_FOR_TOPIC, fetchInitiativesForTopicSaga),
  takeEvery(EventType.FETCH_FOR_ID, fetchEventsByIdSaga),
  takeEvery(EventType.FETCH_FOR_TOPIC, fetchEventsForTopicSaga),
  takeEvery(StakeholderActionTypes.FETCH_FOR_TOPIC, fetchStakeholdersForTopicSaga),
  takeEvery(StakeholderActionTypes.FETCH_FOR_ID, fetchStakeholderByIdSaga),
  takeEvery(KnowledgeDataActionTypes.FETCH_FOR_TOPIC, fetchKnowledgeDataForTopicSaga),
  takeEvery(VideoActionTypes.FETCH_FOR_TOPIC, fetchVideosForTopicSaga),
  takeLatest(LanguageActionTypes.FETCH_ALL, fetchLanguagesSaga),
  takeLatest(TopicActionType.FETCH_HIGHLIGHTS, fetchHighlightedTopicsSaga),
  takeEvery(TopicActionType.FETCH_FOLLOWED_LIST, fetchFollowedTopicsSaga),
  takeEvery([TopicActionType.FETCH_OF_TYPE, TopicActionType.FETCH_SHARED_WITH_ME], fetchTopicsOfTypeSaga),
  takeEvery(TopicActionType.FETCH_TOPIC, fetchTopicSaga),
  takeEvery(TopicActionType.FETCH_TOPICS_FOR_COLLECTION, fetchTopicsForCollectionSaga),
];
